<template>
  <or-layout>
    <a-row :gutter="[16, 16]" type="flex" justify="space-between">
      <a-col :span="5">
        <a-button type="primary" @click="tableAdd">创建</a-button>
      </a-col>
      <a-col>
        <a-form layout="inline">
          <a-form-item>
            <a-select :disabled="changeCoueseFlag" v-model="searchFrom.course_id" style="width: 240px" placeholder="课程">
              <a-select-option value="">全部</a-select-option>
              <a-select-option v-for="(item) in courseList" :key="item.id" :value="item.id">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item>
            <a-input placeholder="章节名字" v-model="searchFrom.keyword" @keyup.enter="tableSearch"></a-input>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" htmlType="submit" icon="search" @click="tableSearch"></a-button>
          </a-form-item>
        </a-form>
      </a-col>
    </a-row>
    <a-divider></a-divider>
    <div>
      <a-table :dataSource="data" :rowKey="item => item.id" :pagination="pageinfo" :loading="loading"
        @change="onPaginationChange" bordered>
        <a-table-column key="name" title="章节名字" data-index="name" />
        <a-table-column key="coursename" title="课程名字" data-index="coursename" />
        <a-table-column key="weigh" title="排序" data-index="weigh" />
        <a-table-column key="status" width="100px;" title="状态">
          <template slot-scope="item">
            <span v-if="item.status == 1">可用</span>
            <span v-if="item.status == 0">已禁用</span>
          </template>
        </a-table-column>
        <a-table-column key="active" width="220px" title="操作">
          <template slot-scope="item">
            <a-button v-if="item.status == 0" @click="changeStatus({ id: item.id, status: 1, pid: item.pid })" class="active_btn"
              size="small" type="link">启用
            </a-button>
            <a-button v-if="item.status == 1" @click="changeStatus({ id: item.id, status: 0, pid: item.pid })" class="active_btn"
              size="small" type="link">禁用
            </a-button>
            <a-button v-if="item.status == 1" @click="tableEdit(item)" class="active_btn" size="small" type="link">编辑
            </a-button>
            <a-button v-if="item.status == 1" @click="bindMiss(item)" class="active_btn" size="small" type="link">任务信息
            </a-button>
          </template>
        </a-table-column>
      </a-table>
    </div>
    <a-modal :visible="visible" title="课程信息" @ok="modalSave" :destroyOnClose="true" @cancel="modalCancel">
      <a-form>
        <a-input type="hidden" v-model="form.id" />
        <a-form-item>
          <a-input v-model="form.name" placeholder="章节名字" />
        </a-form-item>
        <a-form-item>
          <a-select :disabled="changeCoueseFlag" v-model="form.course_id" placeholder="课程" allow-clear>
            <a-select-option v-for="(item) in courseList" :key="item.id" :value="item.id">{{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-input v-model="form.weigh" placeholder="排序" />
        </a-form-item>

      </a-form>
    </a-modal>
    <a-modal :visible="bindVisible" title="绑定任务" @ok="modalBindSave" :destroyOnClose="false" @cancel="modalCancel"
      :width="800">
      <a-form>
        <a-input type="hidden" v-model="bindForm.chapter_id" />
        <a-form-item label="已有任务">
          <div v-for="item in bindMissList" :key="item.mission_id + item.id">
            <span>{{ item.name }} - {{ item.missionname }}</span>-
            <span v-if="item.startorend == 0">开始前</span>
            <span v-if="item.startorend == 1">结束后</span>
            <span> {{ item.interval_time }} 小时,持续:{{ item.continuetime }} 小时 </span>
            <view-exam-modal
              :item="{ id: item.examination_id, typename: item.testpapertypename, semestername: item.semestername, gradename: item.gradename, name: item.testpapername }" />
            <a-button type="error" style="margin-left: 10px"
              @click="delChapterMission({ mission_id: item.mission_id, chapter_id: item.id })">删除
            </a-button>
          </div>
        </a-form-item>
        <a-form-item label="任务筛选">
          <a-tree-select style="width: 150px;" v-model="bindSearchForm.testpaper_type" :treeData="typelist"
            :replaceFields="{ children: 'children', title: 'name', key: 'name', value: 'id' }" placeholder="选择试卷分类" allowClear
            @change="bindSearchMission"></a-tree-select>
          <a-select v-model="bindSearchForm.grade_id" placeholder="年级" allow-clear style="width: 100px;margin-left: 10px;"
            @change="bindSearchMission">
            <a-select-option v-for="item in gradeList" :key="item.id" :value="item.id">{{ item.name }}
            </a-select-option>
          </a-select>
          <a-select v-model="bindSearchForm.semester_id" placeholder="学期" allow-clear
            style="width: 100px;margin-left: 10px;" @change="bindSearchMission">
            <a-select-option v-for="item in semesterList" :key="item.id" :value="item.id">{{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="选择新任务">
          <a-select v-model="bindForm.mission_id" placeholder="任务" allow-clear>
            <a-select-option v-for="item in missList" :key="item.id" :value="item.id">{{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-input type="number" v-model="bindForm.interval_time" placeholder="发布时间(负数提前发布,正数推后发布,单位小时)" />
        </a-form-item>
        <a-form-item>
          <a-select v-model="bindForm.startorend" placeholder="时间关系">
            <a-select-option :key="0" :value="0">开始时间</a-select-option>
            <a-select-option :key="1" :value="1">结束时间</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-input type="number" v-model="bindForm.continuetime" placeholder="任务有效时间(单位分钟)" />
        </a-form-item>

      </a-form>
    </a-modal>
  </or-layout>
</template>

<script>
import AFormItem from "ant-design-vue/es/form/FormItem";
import ViewExamModal from '@/components/question/view-exam-modal.vue';

export default {
  components: { AFormItem, ViewExamModal },
  data() {
    return {
      data: [],
      pageinfo: { total: 1, current: 1, pageSize: 12 },
      loading: false,
      visible: false,
      bindVisible: false,
      changeCoueseFlag: false,
      courseList: [],
      bindMissList: [],
      searchFrom: {
        keyword: "",
        course_id: ""
      },
      missList: [],
      form: {
        id: "",
        name: "",
        course_id: "",
        weigh: 0
      },
      gradeList: [],
      semesterList: [],
      typelist: [],
      bindSearchForm: {
        testpaper_type: undefined,
        grade_id: undefined,
        semester_id: undefined
      },
      bindForm: {
        chapter_id: undefined,
        mission_id: undefined,
        interval_time: undefined,
        startorend: undefined,
        continuetime: undefined
      }
    };
  },
  mounted() {
    let course_id = this.$route.query.course_id;
    if (course_id) {
      this.form.course_id = course_id;
      this.searchFrom.course_id = course_id;
      this.changeCoueseFlag = true;
    }
    // this.getMissList();
    this.getCourseList();
    this.tableSearch();

    //获取年级列表
    this.$axios
      .post("/api/BasicGrade/index", { pageinfo: { pageSize: 9999 } })
      .then((res) => {
        if (res.code != 200) {
          this.$error({
            title: "错误",
            content: res.msg,
            okText: "确定",
          });
        } else {
          this.gradeList = res.data.data;
        }
      })
      .catch((err) => {
        console.error(err);
      });
    //获取季度列表
    this.$axios
      .post("/api/BasicSemester/index", { pageinfo: { pageSize: 9999 } })
      .then((res) => {
        if (res.code != 200) {
          this.$error({
            title: "错误",
            content: res.msg,
            okText: "确定",
          });
        } else {
          this.semesterList = res.data.data;
        }
      })
      .catch((err) => {
        console.error(err);
      });
    //获取试卷类型
    this.$axios
      .post("/api/QuestionTestpaperType/index")
      .then((res) => {
        if (res.code != 200) {
          this.$error({
            title: "错误",
            content: res.msg,
            okText: "确定",
          });
        } else {
          this.typelist = res.data;
        }
      })
      .catch((err) => {
        console.error(err);
      });


  },
  methods: {
    modalBindSave() {
      if (!this.bindForm.chapter_id || !this.bindForm.mission_id) {
        this.$error({
          title: "错误",
          content: "请选择一个任务",
          okText: "确定"
        });
        return false;
      }
      let _this = this;
      this.$axios
        .post("/api/BasicChapter/chaptermissionadd", { data: this.bindForm })
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            // _this.tableSearch();
            let tempId = this.bindForm.chapter_id;
            _this.bindForm = {};
            this.bindMiss({ id: tempId });
            // _this.bindVisible = false;
          }
        })
        .catch(err => {
          console.error(err);
        });
    }
    ,
    delChapterMission(data) {
      this.$axios
        .post("/api/BasicChapter/chaptermissiondel", { data })
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.bindMiss({ id: data.chapter_id });
          }
        })
        .catch(err => {
          console.error(err);
        });


    }
    ,
    getMissList() {
      this.$axios
        .post("/api/BasicMission/index", { data: this.bindSearchForm, pageinfo: { pageSize: 9999 } })
        .then(res => {
          if (res.code == 200) {
            this.missList = res.data.data;
          }
        })
        .catch(err => {
          console.error(err);
        });
    }
    ,
    getCourseList() {
      this.$axios
        .post("/api/BasicCourse/index")
        .then(res => {
          if (res.code == 200) {
            this.courseList = res.data.data;
          }
        })
        .catch(err => {
          console.error(err);
        });
    }
    ,

    selectItem(pid) {
      this.form.pid = pid;
    }
    ,
    bindMiss(item) {
      this.bindForm.chapter_id = item.id;
      this.$axios
        .post("/api/BasicChapter/chatermissionindex", { data: { chapter_id: item.id } })
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.bindMissList = res.data;
            this.bindVisible = true;
          }
        })
        .catch(err => {
          console.error(err);
        });

    }
    ,
    changeStatus(data) {
      this.$axios
        .post("/api/BasicChapter/edit", { data })
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.getTableList();
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    onPaginationChange(item) {
      this.pageinfo.current = item.current;
      this.tableSearch();
    },
    tableSearch() {
      this.getTableList(this.searchFrom);
    },
    getTableList(data) {
      this.$axios
        .post("/api/BasicChapter/index", {
          data, pageinfo: this.pageinfo
        })
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.data = res.data.data;
            this.pageinfo = res.data.pageinfo;
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    tableEdit(item) {
      this.form.id = item.id;
      this.form.name = item.name;
      this.form.course_id = item.course_id;
      this.form.weigh = item.weigh;
      this.visible = true;
    },
    tableAdd() {
      this.form = {};
      this.form.course_id = this.searchFrom.course_id;
      this.visible = true;
    },
    tableDel(data) {
      let _this = this;
      this.$confirm({
        title: "删除权限",
        content: "确认删除当前权限吗?",
        okText: "确认",
        cancelText: "取消",
        onOk: function () {
          _this.$axios
            .post("/api/BasicChapter/del", { data })
            .then(res => {
              if (res.code != 200) {
                _this.$error({
                  title: "错误",
                  content: res.msg,
                  okText: "确定"
                });
              } else {
                _this.searchbtn()
              }
            })
            .catch(err => {
              console.error(err);
            });
        }
      });
    },
    bindSearchMission() {
      this.bindForm.mission_id = undefined;
      this.getMissList();
    },
    modalSave() {
      let _this = this;
      if (!this.form.course_id) {
        _this.$error({
          title: "错误",
          content: "必须选择所属课程",
          okText: "确定"
        });
        return false;
      }
      let url = "/api/BasicChapter/edit";
      if (!this.form.id) {
        url = "/api/BasicChapter/add";
      }
      this.$axios
        .post(url, { data: this.form })
        .then(res => {
          if (res.code != 200) {
            _this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            _this.visible = false;
            _this.getTableList(_this.searchFrom);
          }
        })
        .catch(err => {
          console.error(err);
        });

    },
    modalCancel() {
      this.visible = false;
      this.bindVisible = false;
    }
  }
}
  ;
</script>
<style>
.active_btn {
  margin-left: 5px;
}
</style>